import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-marketplace-not-authorized',
  imports: [TranslatePipe],
  template: `
    <div class="flex h-screen w-screen flex-col items-center justify-center gap-4 bg-white p-4">
      <h2 class="text-lg font-semibold kiosk:text-8xl">
        {{ 'marketplace.errors.marketplace_not_authorized' | translate }}
      </h2>
      <p class="text-center kiosk:text-4xl">
        {{ 'marketplace.errors.marketplace_not_authorized_message' | translate }}
      </p>
    </div>
  `,
})
export class MarketPlaceNotAuthorizedComponent {}
